var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.441,
    height: 23.487,
    viewBox: "0 0 16.441 23.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 16.441,
    height: 23.487,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 -0.002)",
    clipPath: "url(#lock-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M14.952,426.979H1.489A1.489,1.489,0,0,0,0,428.468v11.114a1.489,1.489,0,0,0,1.489,1.489H14.952a1.489,1.489,0,0,0,1.489-1.489V428.468a1.489,1.489,0,0,0-1.489-1.489m-4.894,10.144a.449.449,0,0,1-.443.523H6.826a.449.449,0,0,1-.443-.523l.429-2.574a2.312,2.312,0,1,1,2.817,0Z",
    transform: "translate(0 -417.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M102.779,8.8V6.207c0-.206,0-.41.021-.615a4.685,4.685,0,0,1,.217-.793,4.706,4.706,0,0,1,.41-.7A4.739,4.739,0,0,1,104,3.525a4.705,4.705,0,0,1,.7-.41,4.685,4.685,0,0,1,.8-.218,4.757,4.757,0,0,1,.851,0,4.685,4.685,0,0,1,.8.218,4.7,4.7,0,0,1,.7.41,4.738,4.738,0,0,1,.571.571,4.705,4.705,0,0,1,.41.7,4.683,4.683,0,0,1,.217.794c.036.415.021.837.021,1.253V8.8h2.879V6.227a6.193,6.193,0,0,0-.365-2.259,5.983,5.983,0,0,0-.772-1.457,6.949,6.949,0,0,0-.639-.762,7.072,7.072,0,0,0-.765-.635,6.014,6.014,0,0,0-8.738,1.968A6.156,6.156,0,0,0,99.9,6.048q0,1.375,0,2.75Z",
    transform: "translate(-97.701 0.002)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.59311f3b61f27364ed79a41e3f5398e6.svg";
export { ForwardRef as ReactComponent };